export default "__VITE_ASSET__K99afOI0__ 600w";